import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useParams } from "react-router-dom";


const ViniPage = () => {
  const { t } = useTranslation();
const { lang } = useParams();

  // Original image paths, as these are not translated
  const genericImages = [
    "/beverahills_vini_tronco.jpg",
    "/beverahills_cartoni.jpg",
    "/beverahills_4_bottiglie.jpg",
    "/beverahills_3_bottiglie.jpg"
  ];

  const [selectedImage, setSelectedImage] = useState(null);
    const prefix = `/${lang}`;

  return (
    <div className="">
      <h1 className="text-4xl font-light text-gray-800 titolo mb-4 text-center">
        {t("vini.titolo_pagina")}
      </h1>

      <div className="container mx-auto px-4 py-8">
        <motion.p
          className="text-xl md:text-2xl text-center text-gray-700 max-w-3xl mx-auto leading-relaxed"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          {t("vini.intro_paragrafo")}
        </motion.p>

        <div className="pt-12 pb-24 grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="flex flex-col gap-6 h-full">
            {genericImages.slice(0, 3).map((img, index) => (
              <motion.img
                key={index}
                src={img}
                alt={`${t("vini.alt_immagine_generica")} ${index + 1}`}
                className="w-full object-cover rounded-xl shadow-lg transform hover:scale-105 transition-transform duration-200"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
              />
            ))}
          </div>
          <motion.img
            src={genericImages[3]}
            alt={t("vini.alt_immagine_verticale")}
            className="hidden lg:block h-full object-cover rounded-xl shadow-lg transform hover:scale-105 transition-transform duration-200"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          />
        </div>

        <div className="space-y-28">

          <motion.div
        key="Bianchi"
        className="bg-white rounded-3xl shadow-2xl overflow-hidden p-8 border border-gray-100"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <h2 className="text-4xl font-light titolo text-center mb-2">
          I nostri Bianchi
        </h2>
        <div className="flex justify-center py-4">
          <motion.div
            className="text-xl md:w-1/3 border rounded-xl shadow-xl p-4 font-medium text-center border-gray-100 cursor-pointer"
            whileHover={{ scale: 1.1 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            Il Biunt
            <a href={`${prefix}/vini/il-biunt`}>
              <img src="/biunt_bottiglia.png" alt="Il Biunt" className="rounded-xl py-4" />
            </a>
          </motion.div>
        </div>
      </motion.div>

      <motion.div
        key="Rossi"
        className="bg-white rounded-3xl shadow-2xl overflow-hidden p-8 border border-gray-100"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <h2 className="text-4xl font-light titolo text-center mb-2">
          I nostri Rossi
        </h2>
        <div className="flex justify-center py-4">
          <motion.div
            className="text-xl md:w-1/3 border rounded-xl shadow-xl p-4 font-medium text-center border-gray-100 cursor-pointer"
            whileHover={{ scale: 1.1 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            Germoglio
            <a href={`${prefix}/vini/germoglio`}>
              <img src="/germoglio_bottiglia.png" alt="Germoglio" className="rounded-xl py-4" />
            </a>
          </motion.div>
        </div>
      </motion.div>

          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden p-8 border border-gray-100">
            <h2 className="text-4xl font-bold titolo text-center mb-2">
              {t("vini.riconoscimenti")}
            </h2>

            <div className="flex md:flex-row flex-col justify-center gap-6 px-4 mt-10">
              {[
                "/Diploma_prosit_Beverahills_Biunt.svg",
                "/Diploma_prosit_Beverahills_Germoglio.svg",
              ].map((src, i) => (
                <motion.img
                  key={i}
                  src={src}
                  alt={`Diploma ${i + 1}`}
                  className="rounded-xl shadow-lg border border-gray-200 transform hover:scale-105 transition-transform duration-200 max-h-[400px] cursor-pointer"
                  onClick={() => setSelectedImage(src)}
                  whileHover={{ scale: 1.05 }}
                />
              ))}
            </div>

            {/* Overlay fullscreen */}
            <AnimatePresence>
              {selectedImage && (
                <motion.div
                  className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 cursor-pointer"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  onClick={() => setSelectedImage(null)}
                >
                  <motion.img
                    src={selectedImage}
                    alt="Diploma ingrandito"
                    className="max-h-[90vh] max-w-[90vw] rounded-xl shadow-2xl border border-white"
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.8, opacity: 0 }}
                    transition={{ type: "spring", stiffness: 200, damping: 20 }}
                  />
                </motion.div>
              )}
            </AnimatePresence>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ViniPage;